import React from "react";
import { Box, SimpleGrid, Icon, Text, Flex, Center,useColorModeValue, Container, Heading} from '@chakra-ui/react';
import { FiBell, FiShield, FiGlobe} from "react-icons/fi";
import Pattern from "assets/images/pattern.svg";

const Feature = ({ title, text, icon }) => {
  return (
    <Box boxShadow='dark-lg' p='6' rounded='md' bg='#2f3084'>
       <Center>
        <Flex
          w={16}
          h={16}
          align={'center'}
          justify={'center'}
          color="brand.500"
          rounded={'full'}
          bg={'gray.100'}
          mb={1} shadow='md'>
              {icon}
        </Flex>
      </Center>
      <Center>
      <Text color="white" textAlign="center" fontSize={{base:'sm',sm:'md',md:'lg',lg:'xl'}} fontFamily="ManropeRegular">{title}</Text>
      </Center>
      <Text color="white" textAlign="center" fontSize={{base:'sm',sm:'sm',md:'md',lg:'lg'}} fontFamily="ManropeLight">{text}</Text>
    </Box>
  );
};

const HowItWorksHeading = ({ children }) => {
  return (
    <Heading as={'h3'} fontSize={{ base: 'xl', sm: '2xl', md: '4xl' }} textAlign={'center'} color="black" fontFamily="ManropeSemiBold">
      {children}
    </Heading>
  );
};

const HowItWorksText = ({ children }) => {
  return (
    <Text
      textAlign={'center'}
      color="#000" fontFamily="ManropeRegular"
       fontSize={{base:'sm',sm:'md',md:'lg',lg:'xl'}} mt="4">
      {children}
    </Text>
  );
};

export default function SimpleThreeColumns() {
  return (
    <Box p={4} background="white" backgroundPosition="top center" backgroundSize="contain">
         <Center width="100%" minH="50px">
          <Container columns={{ base: 1, md: 1 }} width="80%" mt="5">
          <HowItWorksHeading>Features of our <Text as="span" color="brand.500">virtual card</Text> </HowItWorksHeading>
          <HowItWorksText>
           Perfect card for the perfect moment
         </HowItWorksText>
       </Container>
       </Center>

       <Center width="100%" minH="300px" mt="5" mb="5">
       <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} width="80%">
        <Feature
          icon={<Icon as={FiBell} w={10} h={10} />}
          title={'Visibility into Purchases'}
          text={
            'Real-time notification on every transactions as it happens. See what you spend in real-time'
          }
        />
        <Feature
          icon={<Icon as={FiShield} w={10} h={10}/>}
          title={'One Click Fraud Prevention'}
          text={
            'We provide every thing you need to protect your account and card from fraud and compromise'
          }
        />
        <Feature
          icon={<Icon as={FiGlobe} w={10} h={10} />}
          title={'Globally Accepted'}
          text={
            'You can use your virtual debit card anywhere that accepts credit cards'
          }
        />
      </SimpleGrid>
      </Center>
    </Box>
  );
}